"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReportResourcePath = exports.buildSnapshotArchivePath = exports.buildSnapshotPath = exports.buildCommitStatusOverviewJSONPath = exports.buildAggregateReviewJSONPath = exports.buildReviewJSONPath = exports.buildReportJSONPath = exports.buildReportPath = exports.buildReportsPath = exports.buildCommitPath = exports.buildRepositoryPath = void 0;
function buildRepositoryPath(context) {
    return `repositories/${context.repository}`;
}
exports.buildRepositoryPath = buildRepositoryPath;
function buildCommitPath(context) {
    return `${buildRepositoryPath(context)}/commits/${context.commitHash}`;
}
exports.buildCommitPath = buildCommitPath;
function buildReportsPath(context) {
    return `${buildCommitPath(context)}/reports`;
}
exports.buildReportsPath = buildReportsPath;
function buildReportPath(context) {
    return `${buildCommitPath(context)}/reports/${context.reportName}`;
}
exports.buildReportPath = buildReportPath;
function buildReportJSONPath(context) {
    return `${buildReportPath(context)}/report.json`;
}
exports.buildReportJSONPath = buildReportJSONPath;
function buildReviewJSONPath(context) {
    return `${buildCommitPath(context)}/review.json`;
}
exports.buildReviewJSONPath = buildReviewJSONPath;
function buildAggregateReviewJSONPath(context) {
    return `${buildCommitPath(context)}/aggregate_review.json`;
}
exports.buildAggregateReviewJSONPath = buildAggregateReviewJSONPath;
function buildCommitStatusOverviewJSONPath(context) {
    return `${buildCommitPath(context)}/status.json`;
}
exports.buildCommitStatusOverviewJSONPath = buildCommitStatusOverviewJSONPath;
function buildSnapshotPath(context) {
    return `${buildCommitPath(context)}/snapshots/${context.snapshotName}`;
}
exports.buildSnapshotPath = buildSnapshotPath;
function buildSnapshotArchivePath(context) {
    return `${buildSnapshotPath(context)}/archive.zip`;
}
exports.buildSnapshotArchivePath = buildSnapshotArchivePath;
// Regression tests
function buildReportResourcePath(context) {
    return `${buildReportPath(context)}/resources/${context.filename}`;
}
exports.buildReportResourcePath = buildReportResourcePath;
